export const environment = {
  production: false,
  beta: true,
  sentryDsn: 'https://2e2486fc2a504b32b9f806ba6936d25a@o504450.ingest.sentry.io/5597209',
  serverUrl: 'https://preprod.annuaires.k3d-sarl.fr/',
  oauthUrl: 'https://preprod.oauth.k3d-sarl.fr/',
  appVersion: require('package.json').version,
};
